// extracted by mini-css-extract-plugin
module.exports = {"spinning":"ImportModal_spinning__1-bgT","uploadBtn":"ImportModal_uploadBtn__1NEwa"};